<template>
    <div class="l-goal-cycle-timeline">
        <div class="timeline-wrapper">
            <ol class="timeline">
                <li
                    v-b-popover.hover.top="{
                        content: $t(`goals.cycle.details.timelinePopover.planDate`),
                    }"
                    class="timeline-event help"
                    :style="`left:${timeline.plan}%;`"
                >
                    <span class="timeline-event-date">
                        {{ plan | moment("MMM DD, YYYY") }}
                    </span>
                </li>
                <li
                    v-show="plan !== active"
                    v-b-popover.hover.top="{
                        content: $t(`goals.cycle.details.timelinePopover.activeDate`),
                    }"
                    class="timeline-event help"
                    :style="`left:${timeline.active}%;`"
                >
                    <span class="timeline-event-date">
                        {{ active | moment("MMM DD, YYYY") }}
                    </span>
                </li>
                <li
                    v-b-popover.hover.top="{
                        content: $t(`goals.cycle.details.timelinePopover.endDate`),
                    }"
                    class="timeline-event help"
                    :style="`right:${timeline.end}%;`"
                >
                    <span class="timeline-event-date">
                        {{ end | moment("MMM DD, YYYY") }}
                    </span>
                </li>
            </ol>

            <!-- Phases -->
            <span
                v-show="plan !== active"
                v-b-popover.hover.top="{
                    content: $t(`goals.cycle.details.timelinePopover.plan`),
                }"
                class="timeline-label help"
                :style="`left:${timeline.active / 2}%`"
            >
                {{ $t(`goals.cycle.list.timeline.plan`) }}</span
            >
            <span
                v-b-popover.hover.top="{
                    content: $t(`goals.cycle.details.timelinePopover.active`),
                }"
                class="timeline-label help"
                :style="`left:${timeline.active + (100 - timeline.active) / 2}%`"
            >
                {{ $t(`goals.cycle.list.timeline.active`) }}</span
            >
            <!-- / Phases -->

            <!-- Progress -->
            <div
                v-show="showProgress"
                class="timeline-progress"
                role="progressbar"
                :style="`width:${progress}%;`"
            ></div>
            <!-- / Progress -->
        </div>
    </div>
</template>

<script>
import { isValidDateString } from "@/utils/is-valid";

export default {
    props: {
        plan: {
            type: Date,
            required: true,
        },
        active: {
            type: Date,
            required: true,
        },
        end: {
            type: Date,
            required: true,
        },
        showProgress: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            error: false,
            timeline: {},
            progress: 0,
        };
    },
    watch: {
        plan: {
            handler() {
                this.updateTimelinePreview();
            },
        },
        active: {
            handler() {
                this.updateTimelinePreview();
            },
        },
        end: {
            handler() {
                this.updateTimelinePreview();
            },
        },
    },
    created() {
        this.updateTimelinePreview();
    },
    methods: {
        updateTimelinePreview() {
            if (
                !isValidDateString(this.plan) ||
                !isValidDateString(this.active) ||
                !isValidDateString(this.end)
            ) {
                return;
            }

            const duration = new Date(this.end) - new Date(this.plan);

            this.timeline.plan = -5;
            this.timeline.active = ((new Date(this.active) - new Date(this.plan)) / duration) * 100;
            this.timeline.end = -5;

            this.progress = Math.min(((new Date() - new Date(this.plan)) / duration) * 100, 100);

            // To avoid date labels to overlap, we make sure that the Active marker
            // is at least at 10% of the timeline.
            // We then need to recalculate the progress accordingly, as now the scales
            // are different for the Drafting phase and the Active phase
            //
            if (this.timeline.active < 10) {
                if (this.progress < 10) {
                    this.progress = (this.progress / this.timeline.active) * 10;
                }

                this.timeline.active = 10;
            } else if (this.timeline.active > 80) {
                if (this.progress < this.timeline.active) {
                    this.progress = this.progress - this.timeline.active + 80;
                }

                this.timeline.active = 80;
            }
        },
    },
};
</script>

<style scoped></style>
